import React from "react"
import Helmet from "react-helmet"

import Layout from "../components/layout"

const Contributors = () => (
  <Layout>
    <Helmet title="Contributors | Roberttables" />
    <h1>Contributors Page</h1>
  </Layout>
)

export default Contributors
